
















import {Vue, Component, Prop} from "vue-property-decorator";
import {Notification as NotificationModel} from "@api/models/notifications/Notification";
import Notification from "./Notification.vue";
import {UserProfile} from "@api/models/UserProfile";
import CloseBtn from "@share/common/CloseBtn.vue";

@Component({
    components: { CloseBtn, Notification }
})
export default class NotificationsList extends Vue {
    @Prop() list: NotificationModel[];
    @Prop() profiles: UserProfile[];

    profile(userId?: number|null): UserProfile|null {
        if (userId === null || userId === undefined) {
            return null;
        }
        return this.profiles[userId] ?? null;
    }
}
